import { ShowTimeDisplayType } from '@/interface/enum';
import { formatDate, formatToSingaporeTime } from '@/libraries/utils/date';

const shouldDisplayTime = [
    ShowTimeDisplayType.BlueLive,
    ShowTimeDisplayType.RedLive,
    ShowTimeDisplayType.DateTime,
];

export function formatShowTime(dateTime: string, showTimeType: ShowTimeDisplayType) {
    if (shouldDisplayTime.find(x => x & showTimeType)) {
        const date = new Date(dateTime);
        return formatDate(date, 'HH:mm');
    }

    if (showTimeType & ShowTimeDisplayType.Date) {
        return '**:**';
    }

    return '';
}

export function formatShowTimeDisplayByDate(dateTime: Date, showTimeType: ShowTimeDisplayType) {
    if (shouldDisplayTime.find(x => x & showTimeType)) {
        return formatToSingaporeTime(dateTime, 'HH:mm');
    }

    if (showTimeType & ShowTimeDisplayType.Date) {
        return '**:**';
    }

    return '';
}
